export default __webpack_public_path__ + "static/media/Deed of Contract_10.b5c9ef90.jpg";